import { motion } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";

import cocktailsVideo from "../../../assets/StoryPage/cocktails.mp4";
import buffetsVideo from "../../../assets/StoryPage/buffets.mp4";
import mariagesVideo from "../../../assets/StoryPage/mariages.mp4";

const menuItems = [
  {
    title: "Mocktails",
    subtitle: "Food",
    video: cocktailsVideo,
    path: "/menu/drinks",
  },
  {
    title: "Main Courses",
    subtitle: "Food",
    video: buffetsVideo,
    path: "/menu/Dinner",
  },
  {
    title: "Desserts",
    subtitle: "Food",
    video: mariagesVideo,
    path: "/menu/desserts",
  },
];

const VideoMenuCard = ({ video, title, subtitle, path }) => {
  const videoRef = useRef(null);

  const play = () => videoRef.current?.play();
  const stop = () => {
    if (!videoRef.current) return;
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
  };

  return (
    <Link
      to={path}
      className="group block cursor-pointer focus:outline-none"
      onMouseEnter={play}
      onMouseLeave={stop}
    >
      {/* VIDEO */}
      <div className="relative h-[260px] overflow-hidden bg-black">
        <video
          ref={videoRef}
          src={video}
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/25" />
      </div>

      {/* TEXT */}
      <div className="mt-5 text-center">
        <h4 className="text-sm tracking-[0.25em] uppercase text-primary-700 group-hover:text-primary-900 transition">
          {title}
        </h4>
        <p className="mt-1 text-xs tracking-widest text-primary-500">
          {subtitle}
        </p>
      </div>
    </Link>
  );
};

const StoryPage = () => {
  return (
    <section className="bg-background-soft py-20">
      <div className="max-w-6xl mx-auto px-4">

        {/* HEADER */}
        <div className="text-center mb-14">
          <p className="text-xs tracking-widest uppercase text-primary-600 mb-3">
            Eelaa’s Tasty Offer
          </p>
          <h2 className="text-3xl tracking-wide text-primary-900">
            Our Menu
          </h2>
        </div>

        {/* GRID */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10"
        >
          {menuItems.map((item, index) => (
            <VideoMenuCard
              key={index}
              video={item.video}
              title={item.title}
              subtitle={item.subtitle}
              path={item.path}
            />
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default StoryPage;
